import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchPublicProfile } from "@/lib/api";
import ListingCard from "@/components/listings/ListingCard";
import { Loader2, User, MapPin } from "lucide-react";

export default function PublicProfile() {
  const { userId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchPublicProfile(userId).then(setData).catch(() => setData(null)).finally(() => setLoading(false));
  }, [userId]);

  if (loading) return <div className="min-h-[50vh] grid place-items-center"><Loader2 className="w-8 h-8 animate-spin" style={{ color: "var(--amd-primary)" }} /></div>;
  if (!data) return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 text-center">
      <h1 className="text-xl font-black text-white">Utilizator inexistent</h1>
      <Link to="/" className="amd-link mt-4 inline-block">← Înapoi acasă</Link>
    </div>
  );
  const u = data.user;
  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 md:py-8 fade-in">
      <div className="flex items-center gap-4 amd-card rounded-lg p-5">
        <div className="w-16 h-16 rounded-full grid place-items-center text-white font-black text-2xl shrink-0" style={{ background: "var(--amd-primary)" }}>
          {u.picture ? <img src={u.picture} alt="" className="w-16 h-16 rounded-full object-cover" /> : <User className="w-7 h-7" />}
        </div>
        <div className="min-w-0">
          <h1 className="text-xl md:text-2xl font-black text-white truncate">{u.name}</h1>
          <div className="text-xs flex flex-wrap items-center gap-3 mt-1" style={{ color: "var(--amd-text-muted)" }}>
            {u.city && <span className="inline-flex items-center gap-1"><MapPin className="w-3 h-3" /> {u.city}</span>}
            {u.member_since && <span>Membru din {new Date(u.member_since).toLocaleDateString("ro-RO")}</span>}
            <span>{data.total} anunțuri active</span>
          </div>
        </div>
      </div>

      <h2 className="mt-6 text-lg font-black text-white">Anunțuri active</h2>
      {data.listings.length === 0 ? (
        <div className="amd-card rounded-lg p-10 text-center mt-3 text-sm" style={{ color: "var(--amd-text-muted)" }}>Fără anunțuri active.</div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 mt-3">
          {data.listings.map((l) => <ListingCard key={l.id} listing={l} />)}
        </div>
      )}
    </div>
  );
}
